<template>
  <div class="container">
    <div class="col-lg-8 col-md-8 ml-auto mr-auto">
      <h1>За одоо болсоон Баатраатай яриарай</h1>
      
      <router-link to="/signIn"><h3>Нэвтрэх</h3></router-link>
    </div>
  </div>
</template>
<script>
import { BaseCheckbox } from 'src/components';
import { signUp } from '@/utils/auth.js'
export default {
  components: {
    BaseCheckbox
  },
  data() {
    return {
      model: {
        email: '',
        password: ''
      }
    };
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    async register() {
      signUp(this.model.email, this.model.password)
      // let isValidForm = await this.$validator.validateAll();
      // if (isValidForm) {
        // TIP use this.model to send it to api and perform register call
      // }
    }
  }
};
</script>
<style></style>
